import { makeStyles } from 'tss-react/mui';

const name = 'ChainPageWidget';

export const useChainPageWidgetStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),

    padding: theme.spacing(8),

    borderRadius: theme.shape.borderRadiusXl,

    backgroundColor: theme.palette.background.paper,

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),

      borderRadius: theme.shape.borderRadiusMd,
    },
  },
}));
